import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withFieldProps } from 'hooks/useFieldProps';
import classnames from 'classnames';
import RawHtml from 'common/RawHtml';
import { AmountBase as Amount } from 'fields/Amount';
import { withStyles } from 'theme/withStyles';

const styles = (theme) => {
  const { spacing, typography } = theme;
  return {
    h3: {
      ...typography.h2,
      display: 'block',
      padding: [spacing.unit, 0],
      textAlign: 'center',
      width: '100%',
    },
  };
};

const getFormattedValueNum = (value) =>
  typeof value === 'string' && value ? parseFloat(value.replace(/[$,]/g, '')) : value || 0;

const AmountMobileTheme = ({ classes, ...props }) => {
  const { defaultValue, label, maxLabel, minLabel, minValue, onChange, value } = props;
  const [fieldDescrOverride, setFieldDescrOverride] = useState('');
  useEffect(() => {
    /** set initial value */
    const initialValue = defaultValue || defaultValue === 0 ? defaultValue : minValue;
    onChange(props.name, getFormattedValueNum(initialValue));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (value < minValue) {
      setFieldDescrOverride(minLabel);
    } else {
      setFieldDescrOverride(maxLabel);
    }
  }, [maxLabel, minLabel, minValue, value]);
  const formattedValueNum = getFormattedValueNum(value);
  return (
    <>
      <RawHtml type="h3" className={classes.h3} id={`label-${props.name}`}>
        {label}
      </RawHtml>
      <div className={classnames('region-other-amount field-type--amount')}>
        <Amount
          {...props}
          fieldDescrOverride={fieldDescrOverride}
          visuallyHideLabelText
          onFocus={() => {
            props.onFocus();
            if (formattedValueNum === 0) {
              onChange(props.name, '');
            }
          }}
        />
      </div>
    </>
  );
};

AmountMobileTheme.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string.isRequired,
  maxLabel: PropTypes.string.isRequired,
  minLabel: PropTypes.string.isRequired,
  minValue: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

AmountMobileTheme.defaultProps = {
  defaultValue: undefined,
};

const StyledAmountMobileTheme = withStyles(styles)(AmountMobileTheme);

const mapStateToProps = ({ fields }, { name }) => {
  const field = fields[name];
  const [minLabel, maxLabel] = field.fieldDescr?.split(', ') ?? [];
  const validator = field.validators.find((v) => v.name === 'amountValidator');
  const { min, productMin } = validator?.configs || {};
  return {
    defaultValue: field.value,
    maxLabel,
    minLabel,
    minValue: parseFloat(productMin ?? min),
  };
};

export default withFieldProps(mapStateToProps)(StyledAmountMobileTheme);
